import { cn } from '@dreamstack/util/src/cn'
import { DisclosureButton } from '@headlessui/react'
import type { FunctionComponent } from 'react'
import {
  expandableTitle,
  StyledDiv,
  StyledHeadingH2,
  StyledMinus,
  StyledPlus,
} from './AccordionStyledComponents'

export const ExpandableBlockDisclosureButton: FunctionComponent<
  React.PropsWithChildren<{
    open: boolean
    title: string
    titleWhenExpanded?: string
    clickHandler?: (index: number, action: boolean) => void
    index?: number
    className?: string
    useAqua?: boolean
    smallSize?: boolean
  }>
> = ({
  open,
  title,
  titleWhenExpanded,
  clickHandler,
  index,
  useAqua,
  smallSize,
  className,
}) => {
  return (
    <>
      <DisclosureButton
        className={cn(
          'text-left w-full text-accentroGray-full focus:outline-none',
          className
        )}
      >
        <StyledDiv useAqua={useAqua}>
          <div
            onClick={() =>
              clickHandler && index ? clickHandler(index, open) : null
            }
            className="contents"
          >
            {open ? (
              <StyledMinus $smallSize={smallSize} />
            ) : (
              <StyledPlus $smallSize={smallSize} />
            )}
            <StyledHeadingH2 className="ml-px-12" smallSize={smallSize}>
              {expandableTitle(title, titleWhenExpanded, open)}
            </StyledHeadingH2>
          </div>
        </StyledDiv>
      </DisclosureButton>
    </>
  )
}
